<!--
   Created by qing on 2020/2/19 2:02 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <van-rate
    v-else
    v-model="current[0]"
    :disabled="disabled"
    :size="20"
    :count="field.maxValue"
    :void-color="field.uncheckColor"
    :allow-half="!!field.halfChoose"
    color="#F7BA2A"
    void-icon="star"
    @change="filterChange">
  </van-rate>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {};
    }
  };
</script>

<style lang="less" rel="stylesheet/less" scoped>

</style>
